import {Coordinates} from '@/common/interfaces/geolocation';

export function checkGeoPermissionAllowed() {
	return !!navigator?.permissions?.query;
}

export async function getGeoPermission() {
	const result = await navigator.permissions.query({name: 'geolocation'});

	if (!result.state) {
		(result as any).state = (result as any).status; // Old browsers (Like Chrome 43) use "status" property
	}

	return result;
}

/**
 * Check is geolocation permission in the current environment is granting only once
 * For now it is only iOS Safari browser
 */
export function isGeolocationPermissionOnce() {
	return navigator.userAgent.includes('iPhone');
}

export async function getGeolocation(options?: PositionOptions) {
	return new Promise<Coordinates>((resole, reject) => {
		navigator.geolocation.getCurrentPosition(
			result => {
				resole({
					lat: result.coords.latitude,
					lng: result.coords.longitude,
				});
			},
			reject,
			options,
		);
	});
}

export async function getGeolocationIfGranted(options?: PositionOptions) {
	if (!checkGeoPermissionAllowed()) {
		return undefined;
	}

	const permission = await getGeoPermission();
	if (permission.state !== 'granted') {
		return undefined;
	}

	return getGeolocation(options);
}
